export enum BookingTypeEnum {
    CouponBooking = 'CouponBooking',
    StoreBooking = 'StoreBooking',
    ManualBooking = 'ManualBooking'
}
